import React, { useState, useEffect, useContext } from "react";
import Blogrightsidebar from "./Blogrightsidebar";
import { BlogContext } from "../../store/BlogContext";

const Bloglists = () => {
    const blogCtx = useContext(BlogContext);
    let date = blogCtx.date ? new Date(blogCtx.date) : new Date();

    // State for fetching blogs for the sidebar
    const [BlogData, setBlogData] = useState({ Blogs: [] });

    useEffect(() => {
        fetch("/blogs.json")
            .then((res) => res.json())
            .then((data) => setBlogData(data))
            .catch((err) => console.error("Error fetching blog data:", err));
    }, []);

    return (
        <section className="blog_area sec_pad">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 blog_sidebar_left">
                        <div className="blog_single mb_50">
                            {blogCtx.image && (
                                <img
                                    className="img-fluid"
                                    src={require(`../../img/new/blog/${blogCtx.image}.jpg`)}
                                    alt=""
                                />
                            )}
                            <div className="blog_content">
                                <div className="post_date">
                                    <h2>
                                        {date.getDate()}
                                        <span>
                                            {date.toLocaleDateString(
                                                "default",
                                                { month: "short" }
                                            )}
                                        </span>
                                    </h2>
                                </div>
                                <div className="entry_post_info">
                                    By: <span> Admin</span>
                                </div>
                                <h5 className="f_p f_size_28 f_500 t_color mb-30">
                                    {blogCtx.title}
                                </h5>
                                <p
                                    className="f_400 mb-30"
                                    dangerouslySetInnerHTML={{
                                        __html: blogCtx.body,
                                    }}
                                ></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <Blogrightsidebar BlogData={BlogData} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Bloglists;